import React from "react"

import { Link, usePathname } from "expo-router"

import { HStack, Text } from "wealthmode-frontend/gluestack/ui"

// Path segments that name a collection or a leaf page. Anything else is the ID
// of a resource in the collection named by the segment before it, and stands in
// the trail under its own ID so the resource page is one click away from any of
// its subpages.
const segmentNames: Record<string, string> = {
  dashboard: "Dashboard",
  clients: "Clients",
  instruments: "Instruments",
  assets: "Assets",
  connectors: "Connectors",
  provider_connectors: "Provider Connectors",
  accounts: "Accounts",
  users: "Users",
  investment_holdings: "Investment Holdings",
  investment_transactions: "Investment Transactions",
  depository_transactions: "Depository Transactions",
  recurring_investment_transactions: "Recurring Investment Transactions",
  recurring_depository_transactions: "Recurring Depository Transactions",
  dividends: "Dividends",
  estimated_account_values: "Estimated Account Values",
  contributions: "Contributions",
  contribution_limits: "Contribution Limits",
  recurring_contributions: "Recurring Contributions",
  occurrences: "Occurrences",
  history: "History",
  sales_charge: "Sales Charge",
}

const AppBreadcrumb = () => {
  const pathname = usePathname()

  const getBreadcrumbs = (location: string) => {
    const parts = location.split("/").filter(Boolean)

    let prefix = ""

    return parts.map((part, index) => {
      prefix = `${prefix}/${part}`

      return {
        pathname: prefix,
        name: segmentNames[part] ?? part,
        active: index + 1 === parts.length,
      }
    })
  }

  const breadcrumbs = getBreadcrumbs(pathname)

  const linkTextClass = "text-base text-foreground-tertiary hover:text-foreground-primary underline"
  const activeTextClass = "text-base text-foreground-secondary font-medium"
  const separatorClass = "text-base text-foreground-tertiary"

  return (
    <HStack className="my-0 gap-2 items-center">
      <Link href="/">
        <Text className={linkTextClass}>Home</Text>
      </Link>
      {breadcrumbs.map((breadcrumb, index) => {
        return (
          <React.Fragment key={index}>
            <Text className={separatorClass}>/</Text>
            {breadcrumb.active ? (
              <Text className={activeTextClass}>{breadcrumb.name}</Text>
            ) : (
              <Link href={breadcrumb.pathname}>
                <Text className={linkTextClass}>{breadcrumb.name}</Text>
              </Link>
            )}
          </React.Fragment>
        )
      })}
    </HStack>
  )
}

export default React.memo(AppBreadcrumb)
